"use client";

import Logo from "@/component/logo";
import { useLanguage } from "@/context/language-context";
import { useTranslations } from "@/hooks/use-translations";
import { routes } from "@/lib/routes";
import {
  Link,
  Navbar,
  NavbarBrand,
  NavbarContent,
  NavbarMenu,
  NavbarMenuItem,
  NavbarMenuToggle
} from "@heroui/react";
import { useState } from "react";
import { Button } from "./override/button.c";

export default function BasicNavbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { language } = useLanguage();
  const t = useTranslations();

  if (!t) return null;

  return (
    <Navbar
      className="static bg-transparent"
      isBlurred={false}
      isMenuOpen={isMenuOpen}
      onMenuOpenChange={setIsMenuOpen}
      classNames={{
        wrapper: "desktop:px-8",
      }}
    >
      <NavbarContent>
        <NavbarMenuToggle
          aria-label={isMenuOpen ? "Close menu" : "Open menu"}
          className="desktop:hidden"
        />
        <NavbarBrand>
          <Logo />
        </NavbarBrand>
      </NavbarContent>

      <NavbarContent className="hidden desktop:flex gap-6" justify="center">
        <NavbarMenuItem>
          <Link href={`${routes.home[language]}#coworking`} className="text-foreground hover:text-primary">
            {t.coworking.title}
          </Link>
        </NavbarMenuItem>
        <NavbarMenuItem>
          <Link href={`${routes.home[language]}#space`} className="text-foreground hover:text-primary">
            {t.space.title}
          </Link>
        </NavbarMenuItem>
        <NavbarMenuItem>
          <Link href={`${routes.home[language]}#people`} className="text-foreground hover:text-primary">
            {t.people.title}
          </Link>
        </NavbarMenuItem>
        {/* <NavbarMenuItem>
          <Link href="/#how-it-works" className="text-foreground hover:text-primary">
            Come funziona
          </Link>
        </NavbarMenuItem> */}
        <NavbarMenuItem>
          <Link href={`${routes.home[language]}#pricing`} className="text-foreground hover:text-primary">
            Prezzi
          </Link>
        </NavbarMenuItem>
        <NavbarMenuItem>
          <Link href={`${routes.home[language]}#faq`} className="text-foreground hover:text-primary">
            FAQ
          </Link>
        </NavbarMenuItem>
        <NavbarMenuItem>
          <Link href="/i-nostri-ospiti" className="text-foreground hover:text-primary">
            Ospiti
          </Link>
        </NavbarMenuItem>
      </NavbarContent>

      <NavbarContent justify="end" className="gap-4">
        <NavbarMenuItem>
          <Button
            as={Link}
            href={routes.requestInfo[language]}
            size="sm"
            variant="bordered"
          >
            {t.navbar.contactUs}
          </Button>
        </NavbarMenuItem>
        <NavbarMenuItem>
          <Button
            as={Link}
            size="sm"
            href={routes.auth[language]}
          >
            {t.navbar.register}
          </Button>
        </NavbarMenuItem>
      </NavbarContent>

      <NavbarMenu>
        <NavbarMenuItem>
          <Link
            href={`${routes.home[language]}#coworking`}
            className="w-full text-foreground"
            size="lg"
            onClick={() => setIsMenuOpen(false)}
          >
            {t.coworking.title}
          </Link>
        </NavbarMenuItem>
        <NavbarMenuItem>
          <Link
            href={`${routes.home[language]}#space`}
            className="w-full text-foreground"
            size="lg"
            onClick={() => setIsMenuOpen(false)}
          >
            {t.space.title}
          </Link>
        </NavbarMenuItem>
        <NavbarMenuItem>
          <Link
            href={`${routes.home[language]}#people`}
            className="w-full text-foreground"
            size="lg"
            onClick={() => setIsMenuOpen(false)}
          >
            {t.people.title}
          </Link>
        </NavbarMenuItem>
        <NavbarMenuItem>
          <Link
            href={`${routes.home[language]}#pricing`}
            className="w-full text-foreground"
            size="lg"
            onClick={() => setIsMenuOpen(false)}
          >
            {t.navbar.pricing}
          </Link>
        </NavbarMenuItem>
        <NavbarMenuItem>
          <Link
            href={`${routes.home[language]}#faq`}
            className="w-full text-foreground"
            size="lg"
            onClick={() => setIsMenuOpen(false)}
          >
            FAQ
          </Link>
        </NavbarMenuItem>
        <NavbarMenuItem>
          <Button
            as={Link}
            href={routes.requestInfo[language]}
            className="w-full"
            size="md"
            variant="bordered"
            onClick={() => setIsMenuOpen(false)}
          >
            {t.navbar.contactUs}
          </Button>
        </NavbarMenuItem>
        <NavbarMenuItem>
          <Button
            as={Link}
            href={routes.auth[language]}
            className="w-full bg-gradient-to-r from-primary to-secondary text-white font-medium"
            onClick={() => setIsMenuOpen(false)}
          >
            {t.navbar.register}
          </Button>
        </NavbarMenuItem>
      </NavbarMenu>
    </Navbar>
  );
}
